<template>
    <div class="collaborations" :class="{ container: $device.isDesktop }">
        <div class="collaborations-manifest text_13 color-text_2">symbios: манифест</div>

        <div class="description">
            <div class="description__content text_11" :class="{ is_minimize: !isMinimizedDescription }">
                Поиск. Взаимодействие. Соавторство. Мы ищем похожих и непохожих на нас творцов, чтобы заражаться свежими
                идеями и создавать новые формы. Это не просто коллаборация, это симбиоз – совместно прожитый проект: от
                зарождения идеи до осязаемой вещи в руках. Для нас это способ не терять флюидность и изменчивость, для
                художников – выходить на новые уровни и аудитории. Настоящий симбиоз.
                <br /><br />
                Exploration. Interaction. Co-authorship. We seek creators both similar and dissimilar to us, with an aim
                to infect ourselves with fresh ideas and craft new forms. It's more than just collaboration; it's
                symbiosis — a jointly-lived project, from the inception of the idea to the tangible creation in our
                hands. For us, it's a way to keep fluidity and adaptability; for artists, it's an opportunity to reach
                new levels and audiences. A true symbiosis.
            </div>
            <div class="description__minimize color-accent text_11">
                <div @click="isMinimizedDescription = !isMinimizedDescription">
                    {{ isMinimizedDescription ? "подробнее" : "свернуть" }}
                </div>
            </div>
            <h1 class="collaborations__title" v-if="$device.isDesktop">SYMBIOS</h1>
        </div>

        <div class="categories text_13">
            <div
                v-for="(category, index) in categories"
                :class="currentCategoryId === category.id ? 'text_border' : null"
                :key="index"
                @click="currentCategoryId = category.id">
                {{ category.name }}
            </div>
            <div :class="currentCategoryId === null ? 'text_border' : null" @click="currentCategoryId = null">
                показать все
            </div>
        </div>

        <div class="cards">
            <template v-for="(post, index) in posts">
                <transition :key="index" name="fade">
                    <NuxtLink
                        :to="'/symbios/' + post.slug"
                        class="cards__item"
                        v-if="post['category_id'] === currentCategoryId || currentCategoryId === null">
                        <UiImage
                            class="cards__img"
                            v-if="post.image"
                            :path="post.image.path"
                            :lazy="false"
                            :desktop="{ width: 748 }" />
                        <div class="cards__content" v-if="$device.isDesktop">
                            <div class="cards__category text_13 mb_25 text_border">
                                {{
                                    post["category_id"] === null
                                        ? "без категории"
                                        : findCategoryNameById(post["category_id"])
                                }}
                            </div>
                            <div class="cards__title mb_25">{{ post.name }}</div>
                            <div class="cards__description text_19 mb_25">{{ post.description }}</div>
                            <div class="cards__publication-info text_13">
                                {{ post.author + " / " + post.date }}
                            </div>
                            <!--                        <div class="cards__reactions">-->
                            <!--                            <div class="cards__reaction cards__reaction_like">-->
                            <!--                                <svg width="15" height="12" viewBox="0 0 15 12" fill="none"-->
                            <!--                                     xmlns="http://www.w3.org/2000/svg">-->
                            <!--                                    <mask id="path-1-inside-1_10013_1959" fill="white">-->
                            <!--                                        <path-->
                            <!--                                            d="M13.8793 1.20812C13.1178 0.42904 12.0621 0 10.9067 0C9.61714 0 8.32525 0.790414 7.49998 1.84045C6.67471 0.790414 5.38286 0 4.0933 0C2.93795 0 1.88225 0.42904 1.12074 1.20808C0.398056 1.94741 0 2.93578 0 3.99115C0 5.13802 0.488918 6.19631 1.53853 7.32172C2.45443 8.3036 5.97889 10.8313 7.49998 12C8.4769 11.2494 11.5312 9.08301 12.2633 8.45426C13.6847 7.23352 15 5.8479 15 3.99119C15 2.93582 14.602 1.94745 13.8793 1.20812Z"/>-->
                            <!--                                    </mask>-->
                            <!--                                    <path-->
                            <!--                                        d="M13.8793 1.20812C13.1178 0.42904 12.0621 0 10.9067 0C9.61714 0 8.32525 0.790414 7.49998 1.84045C6.67471 0.790414 5.38286 0 4.0933 0C2.93795 0 1.88225 0.42904 1.12074 1.20808C0.398056 1.94741 0 2.93578 0 3.99115C0 5.13802 0.488918 6.19631 1.53853 7.32172C2.45443 8.3036 5.97889 10.8313 7.49998 12C8.4769 11.2494 11.5312 9.08301 12.2633 8.45426C13.6847 7.23352 15 5.8479 15 3.99119C15 2.93582 14.602 1.94745 13.8793 1.20812Z"-->
                            <!--                                        :fill="collaboration.likes?'#AC82F1':'#fff'" stroke="black" stroke-width="2"-->
                            <!--                                        mask="url(#path-1-inside-1_10013_1959)"/>-->
                            <!--                                </svg>-->
                            <!--                                {{ collaboration.likes }} лайков-->
                            <!--                            </div>-->
                            <!--                            <div class="cards__reaction cards__reaction_comment">-->
                            <!--                                <svg width="14" height="13" viewBox="0 0 14 13" fill="none"-->
                            <!--                                     xmlns="http://www.w3.org/2000/svg">-->
                            <!--                                    <mask id="path-1-inside-1_9869_7643" fill="white">-->
                            <!--                                        <path-->
                            <!--                                            d="M3.77319 13C4.02714 13 4.2052 12.8749 4.5036 12.599L6.80297 10.5316L11.0906 10.5378C12.9837 10.5442 14 9.50407 14 7.66843V2.86935C14 1.0337 12.9837 0 11.0908 0H2.90917C1.02284 0 0 1.02729 0 2.86935V7.66843C0 9.51022 1.02257 10.5378 2.90917 10.5316H3.20784V12.3547C3.20784 12.7431 3.41734 13 3.77319 13Z"/>-->
                            <!--                                    </mask>-->
                            <!--                                    <path-->
                            <!--                                        d="M3.77319 13C4.02714 13 4.2052 12.8749 4.5036 12.599L6.80297 10.5316L11.0906 10.5378C12.9837 10.5442 14 9.50407 14 7.66843V2.86935C14 1.0337 12.9837 0 11.0908 0H2.90917C1.02284 0 0 1.02729 0 2.86935V7.66843C0 9.51022 1.02257 10.5378 2.90917 10.5316H3.20784V12.3547C3.20784 12.7431 3.41734 13 3.77319 13Z"-->
                            <!--                                        :fill="collaboration.comments?'#AC82F1':'#fff'" stroke="black" stroke-width="2"-->
                            <!--                                        mask="url(#path-1-inside-1_9869_7643)"/>-->
                            <!--                                </svg>-->
                            <!--                                {{ collaboration.comments }} комментариев-->
                            <!--                            </div>-->
                            <!--                        </div>-->
                        </div>
                        <div class="cards__content" v-else>
                            <div class="cards__title mb_25">{{ post.name }}</div>
                            <div class="cards__description text_19 mb_25">{{ post.description }}</div>
                            <div class="cards__publication-info text_13">
                                {{ post.author + " / " + post.date }}
                            </div>
                            <!--                        <div class="cards__reactions">-->
                            <!--                            <div class="cards__category text_19 mb_25 text_border">{{ collaboration.category }}</div>-->
                            <!--                            <div class="cards__reactions_right">-->
                            <!--                                <div class="cards__reaction cards__reaction_like">-->
                            <!--                                    <svg width="15" height="12" viewBox="0 0 15 12" fill="none"-->
                            <!--                                         xmlns="http://www.w3.org/2000/svg">-->
                            <!--                                        <mask id="path-1-inside-1_10013_1959" fill="white">-->
                            <!--                                            <path-->
                            <!--                                                d="M13.8793 1.20812C13.1178 0.42904 12.0621 0 10.9067 0C9.61714 0 8.32525 0.790414 7.49998 1.84045C6.67471 0.790414 5.38286 0 4.0933 0C2.93795 0 1.88225 0.42904 1.12074 1.20808C0.398056 1.94741 0 2.93578 0 3.99115C0 5.13802 0.488918 6.19631 1.53853 7.32172C2.45443 8.3036 5.97889 10.8313 7.49998 12C8.4769 11.2494 11.5312 9.08301 12.2633 8.45426C13.6847 7.23352 15 5.8479 15 3.99119C15 2.93582 14.602 1.94745 13.8793 1.20812Z"/>-->
                            <!--                                        </mask>-->
                            <!--                                        <path-->
                            <!--                                            d="M13.8793 1.20812C13.1178 0.42904 12.0621 0 10.9067 0C9.61714 0 8.32525 0.790414 7.49998 1.84045C6.67471 0.790414 5.38286 0 4.0933 0C2.93795 0 1.88225 0.42904 1.12074 1.20808C0.398056 1.94741 0 2.93578 0 3.99115C0 5.13802 0.488918 6.19631 1.53853 7.32172C2.45443 8.3036 5.97889 10.8313 7.49998 12C8.4769 11.2494 11.5312 9.08301 12.2633 8.45426C13.6847 7.23352 15 5.8479 15 3.99119C15 2.93582 14.602 1.94745 13.8793 1.20812Z"-->
                            <!--                                            :fill="collaboration.likes?'#AC82F1':'#fff'" stroke="black" stroke-width="2"-->
                            <!--                                            mask="url(#path-1-inside-1_10013_1959)"/>-->
                            <!--                                    </svg>-->
                            <!--                                    {{ collaboration.likes }}-->
                            <!--                                </div>-->
                            <!--                                <div class="cards__reaction cards__reaction_comment">-->
                            <!--                                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none"-->
                            <!--                                         xmlns="http://www.w3.org/2000/svg">-->
                            <!--                                        <mask id="path-1-inside-1_9869_7643" fill="white">-->
                            <!--                                            <path-->
                            <!--                                                d="M3.77319 13C4.02714 13 4.2052 12.8749 4.5036 12.599L6.80297 10.5316L11.0906 10.5378C12.9837 10.5442 14 9.50407 14 7.66843V2.86935C14 1.0337 12.9837 0 11.0908 0H2.90917C1.02284 0 0 1.02729 0 2.86935V7.66843C0 9.51022 1.02257 10.5378 2.90917 10.5316H3.20784V12.3547C3.20784 12.7431 3.41734 13 3.77319 13Z"/>-->
                            <!--                                        </mask>-->
                            <!--                                        <path-->
                            <!--                                            d="M3.77319 13C4.02714 13 4.2052 12.8749 4.5036 12.599L6.80297 10.5316L11.0906 10.5378C12.9837 10.5442 14 9.50407 14 7.66843V2.86935C14 1.0337 12.9837 0 11.0908 0H2.90917C1.02284 0 0 1.02729 0 2.86935V7.66843C0 9.51022 1.02257 10.5378 2.90917 10.5316H3.20784V12.3547C3.20784 12.7431 3.41734 13 3.77319 13Z"-->
                            <!--                                            :fill="collaboration.comments?'#AC82F1':'#fff'" stroke="black" stroke-width="2"-->
                            <!--                                            mask="url(#path-1-inside-1_9869_7643)"/>-->
                            <!--                                    </svg>-->
                            <!--                                    {{ collaboration.comments }}-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <!--                        </div>-->
                        </div>
                    </NuxtLink>
                </transition>
            </template>
        </div>
    </div>
</template>

<script>
import UiImage from "../../components/ui/Image.vue";

export default {
    name: "symbios",
    components: { UiImage },
    head() {
        return {
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "keywords",
                    property: "keywords",
                    content: this.seo?.keywords ? this.seo.keywords : "",
                },
            ],
        };
    },
    data() {
        return {
            seo: {},
            posts: [],
            isMinimizedDescription: true,
            categories: [],
            currentCategoryId: null,
            collaborations: [
                {
                    id: 1,
                    slug: "alisa-cayoo",
                    img_link:
                        "https://s3-alpha-sig.figma.com/img/f8bc/aaff/eb9156fefae97c2e8f6f61570fa36db1?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=HZwU~J3uYUQxC6z9n5uCgu0i15ztPVKgl~5YzCUqX2Z8XEEjcictbhtTKeLZdE7LWFsW-UgCgXXmdFyYH2UqD7dlYUWgTniq7VykLAYCWsoo4ZLNEQB7H6tCkIFbqryhyc3wUhTQlxdCuTWarzbp~ZvQ5VuLg6Y2fqEKsVNVLZiAnNOsciHx0LjQYu0rpLWCuo05cQL7ukuUR16XpHJOqkVny2uApmfc9A52HwxmC7bZ5FL7ZF10KNCqLa5mmcBcwv9T~VS9Qw5zsFifiaHcmmLsKCGgikQx5uxUzRZ1eHJ9LajqNQzI~Nvh0ekPqtur495opp5WiNUqp180k6gfyw__",
                    category: "дизайн",
                    title: "симбиоз осязаемых воспоминаний х p.p.s.",
                    description:
                        "наш первый творческий симбиоз с алисой кайо из парижа синтезировался в целую коллекцию осязаемых воспоминаний",
                    author: "алиса кайо",
                    instagram_link: "https://www.instagram.com/pompeznaya_ebuchka?igsh=bWxteHk3MHB5ZzM1",
                    date: "07/03/2024",
                    likes: 0,
                    comments: 0,
                },
                {
                    id: 2,
                    slug: "vika-bis",
                    img_link:
                        "https://s3-alpha-sig.figma.com/img/9922/b62a/098a901c65d39d05e8c816ff7ea9b862?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Nee5CEzKO3Nq1y2sBgtIwlDuCOZZ0t3sOVOE6uTARCgkvQldmEd2Q95GnnQQKee2~fwWxZElc3QeZM6mt2gHDsV6KjS9sIUJyQ88cf9B5Klf8e0H2mCHb4VcmRV6euBgyh8H-Clqb7XA~qKixs-Ge-5onaGfWKY~MJ8xmcb8yLq4A1Qo3XjL2C6zXeEoOTdx6-CnUCdHQ3c3YNTQ2H6z2v-ubyXkvWTsGh7ojkB7~Go3uSrFexqg1RqP63U2RVtFRRp9sozWVzOLwatm6b920~UBg2w8Z~JxUOMBGlG~ruyWQc9J7xjHEz7Hofr8993NJAGWQtUYmOiIDM415kbbXg__",
                    category: "арт",
                    title: "симбиоз телесных исследований и чувств х p.p.s.",
                    description: "мы решили прикоснуться к выраженным на холсте чувствам вики бис",
                    author: "вика бис",
                    instagram_link: "https://www.instagram.com/bis.vika?igsh=ZGxnNDV4MTR4Nno2",
                    date: "07/03/2024",
                    likes: 0,
                    comments: 0,
                },
            ],
        };
    },
    async asyncData({ $axios }) {
        const seo = await $axios.get("/api/seo/symbios");
        return {
            seo: seo.data,
        };
    },
    methods: {
        getCrumbs() {
            return [
                {
                    name: this.$i18n.t("symbios"),
                },
            ];
        },
        async getCategories() {
            try {
                let { data } = await this.$axios.get("/api/symbios/categories");
                this.categories = data;
            } catch (error) {
                console.error(error);
            }
        },
        async getPosts() {
            try {
                let { data } = await this.$axios.get("/api/symbios/posts");
                this.posts = data.reverse();
            } catch (error) {
                console.error(error);
            }
        },
        findCategoryNameById(id) {
            for (let category of this.categories) {
                if (category.id === id) {
                    return category.name;
                }
            }
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.getCrumbs());
        this.getCategories();
        this.getPosts();
    },
};
</script>

<style scoped lang="less">
.collaborations {
    &-manifest {
        margin-bottom: 11px;
        line-height: 21px;
        letter-spacing: 0.16em;
        @media @sm {
            text-align: center;
            color: black;
            padding: 10px 0;
            border-bottom: 1px solid @border2;
            margin: unset;
            font-size: 13px;
            line-height: 13px;
        }
    }

    &__title {
        margin-top: 48px;
        font-size: 40px;
        font-weight: 550;
        line-height: 56px;
        letter-spacing: 3%;
        text-align: left;
    }

    .mb_25 {
        margin-bottom: 25px;
    }

    .mb_10 {
        margin-bottom: 10px;
    }

    .mt_10 {
        margin-top: 10px;
    }

    .text_border {
        text-decoration: underline;
        text-underline-offset: 5px;
    }

    .description {
        margin-bottom: 19px;

        .is_minimize {
            max-height: 500px;
        }

        &__content {
            transition: max-height 0.2s;
            font-size: 11px;
            font-weight: 400;
            line-height: 18px;
            letter-spacing: 0.16em;
            text-align: left;
            max-height: 34px;
            overflow: hidden;
            white-space: normal;
            position: relative;
            @media @sm {
                gap: 10px 25px;
                align-items: center;
                font-size: 11px;
                line-height: 16.5px;
                max-height: 80px;
                overflow: hidden;
                margin-bottom: 10px;
                margin-top: 24px;
            }
        }

        &__minimize {
            margin-top: 16px;
            cursor: pointer;
            line-height: 11px;
            letter-spacing: 0.16em;
        }

        @media @sm {
            border-bottom: 1px solid @border2;
            padding: 0 16px 24px;
            margin-bottom: 13px;
        }
    }

    .categories {
        display: flex;
        gap: 48px;
        align-items: center;
        margin-bottom: 41px;
        line-height: 18px;
        letter-spacing: 0.16em;

        .text_border {
            text-underline-offset: 2px;
        }

        div {
            cursor: pointer;
        }

        div:hover {
            color: #ac82f1;
        }

        @media @sm {
            gap: 10px 25px;
            align-items: center;
            margin-bottom: 41px;
            flex-wrap: wrap;
            padding: 0 16px;
            font-size: 11px;
        }
    }

    .cards {
        &__item {
            display: flex;
            gap: 64px;
            margin-bottom: 80px;
            @media @sm {
                flex-direction: column;
                gap: 24px;
                margin-bottom: unset;
            }
        }

        &__img {
            min-width: 748px;
            min-height: 448px;
            max-width: 748px;
            max-height: 448px;
            object-fit: cover;
            @media @sm {
                min-width: unset;
                min-height: 270px;
                max-width: unset;
                max-height: 270px;
            }
            @media (max-width: 1180px) and (min-width: 750px) {
                width: 50%;
                min-width: unset;
            }
        }

        &__content {
            position: relative;
            @media @sm {
                padding: 0 16px;
                margin-bottom: 30px;
            }
        }

        &__title {
            font-weight: 500;
            font-size: 32px;
            line-height: 44.8px;
            letter-spacing: 0.16em;
            @media @sm {
                font-size: 24px;
                font-weight: 550;
                line-height: 34px;
            }
        }

        &__category {
            font-weight: 400;
            line-height: 18px;
            letter-spacing: 0.16em;
            text-underline-offset: 2px;
            @media @sm {
                font-size: 9px;
                line-height: 13px;
                margin-bottom: unset;
            }
        }

        &__description {
            line-height: 27px;
            letter-spacing: 0.16em;
            @media @sm {
                font-size: 11px;
                line-height: 15px;
            }
        }

        &__publication-info {
            font-weight: 400;
            @media @sm {
                font-size: 9px;
                line-height: 9px;
            }
        }

        &__reactions {
            display: flex;
            gap: 32px;
            position: absolute;
            bottom: 0;
            @media @sm {
                position: static;
                gap: unset;
                justify-content: space-between;
                align-items: center;
                margin-top: 22px;
            }

            &_right {
                display: flex;
                gap: 20px;
            }
        }

        &__reaction {
            display: flex;
            gap: 10px;
            font-size: 13px;
            line-height: 13px;
            letter-spacing: 0.16em;
        }
    }
}
</style>
